<template>
    <div class="container">
        <van-nav-bar
            title="占座宝报表二级平台"
        />
<!--        <div class="header-title">-->
<!--            占座宝报表二级平台-->
<!--        </div>-->
        <van-grid :column-num="3">
            <van-grid-item @click="handlerGoBusTotal" icon="records" text="车辆统计" />
            <van-grid-item @click="handlerGoDriverTotal" icon="sign" text="司机统计" />
            <van-grid-item @click="handlerGoOrderList" icon="balance-list-o" text="订单明细" />
        </van-grid>
        <van-grid :column-num="3">
            <van-grid-item @click="handlerDefault" icon="logistics" text="车辆管理" />
            <van-grid-item @click="handlerDefault" icon="send-gift-o" text="司机管理" />
            <van-grid-item @click="handlerDefault" icon="setting-o" text="账号管理" />
        </van-grid>
    </div>
</template>
<script>
export default {
    data(){
        return {
            message: "hello",
        }
    },
    methods:{
        handlerDefault(){
            this.$notify('功能开发中 ');
        },
        handlerGoBusTotal(){
            this.$router.push({name: "busTotal"});
        },
        handlerGoDriverTotal(){
            this.$router.push({name: "driverTotal"});
        },
        handlerGoOrderList(){
            this.$router.push({name: "orderList"});
        }
    }
}
</script>
<style>
*{
    padding: 0px;
    margin: 0px;
}
.header-title{
    padding: 10px;
    text-align: center;
    color: #1893ff;
    font-size: 16px;
}
</style>


// WEBPACK FOOTER //
// src/components/Index.vue